import React, { useState, useEffect, useRef } from "react";
import { Input, Card, Space, Typography, Button, message, Menu } from "antd";
import {
  SearchOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { CircularProgress } from "@mui/material";
import "./schedule.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom"; // Import useHistory for redirection
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTerms,
  fetchScheduleData,
  generateScheduleData,
  fetchTeachersSchedule,
  fetchSectionsSchedule,
} from "../../store/scheduleDataSlice";
import { fetchPeriods, fetchSchoolDays } from "../../store/schoolDaySlice";
import { fetchAllPeriods } from "../../store/periodManagementSlice";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck";

const { Title } = Typography;

const ScheduleManagement = () => {
//  const terms = useSelector((state) => state.sceduleData.terms);
  const terms = useSelector((state) => state.sceduleData?.terms) || []; // Provide default empty array
  
  const isTermScheduled = useSelector(
    (state) => state.sceduleData?.isTermScheduled
  ) || false;
  const teachersScheduleData =
    useSelector((state) => state.sceduleData?.teachersScheduleData) || [];
  const { periods } = useSelector((state) => state.periods);
  const sectionsScheduleData =
    useSelector((state) => state.sceduleData?.sectionsScheduleData) || [];
  const schoolsScheduleData =
    useSelector((state) => state.sceduleData?.schoolsScheduleData) || [];
  const loading = useSelector((state) => state.sceduleData?.loading || false);
  const { schoolDays } = useSelector((state) => state.schoolDay);

  const [selectedTerm, setSelectedTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const tableRef = useRef(null);

  const [showScheduleFor, setShowScheduleFor] = useState(null);

  const [filters, setFilters] = useState({
    roomName: "",
    schoolDayName: "",
    periodName: "",
  });
  //Modification 2: from line 16 to line 19
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Use useNavigate for React Router v6+


  useTokenExpiryCheck();
  useEffect(() => {
    dispatch(fetchTerms());
    dispatch(fetchAllPeriods());
  }, []);

  useEffect(() => {
    dispatch(fetchPeriods());
    dispatch(fetchSchoolDays());
  }, [dispatch]);

  useEffect(() => {
    console.log("schoolDays.length", schoolDays.length, schoolDays);
    console.log("periods.length", periods.length, periods);
    if (schoolDays.length > 0 && periods.length > 0) {
      const newSchedule = {
        Monday: Array(periods.length).fill(false),
        Tuesday: Array(periods.length).fill(false),
        Wednesday: Array(periods.length).fill(false),
        Thursday: Array(periods.length).fill(false),
        Friday: Array(periods.length).fill(false),
        Saturday: Array(periods.length).fill(false),
        Sunday: Array(periods.length).fill(false),
      };
    }
  }, [schoolDays, periods]);

  useEffect(() => {
    //    applyFilters();
  }, [isTermScheduled, filters]);

  const handleTermChange = (event) => {
    const termID = event.target.value;
    setSelectedTerm(termID);
    console.log("selected term id ", termID);
    dispatch(fetchScheduleData(termID));
  };
  const handleOptionChange = (event) => {
    const option = event.target.value;
    setSelectedOption(option);
    console.log("selected option ", option);
  };

  const handleGenerateSchedule = () => {
    console.log("handleGenerateSchedule", selectedTerm);
    const payload = {
      termID: selectedTerm,
      option: selectedOption,
    };
    console.log("payload", payload);
    dispatch(generateScheduleData(payload));
  };
  useEffect(() => {
    //    applyFilters();
  }, [isTermScheduled]); //schedule is generated

  const handleShowScheduleChange = (event) => {
    setShowScheduleFor(event.target.value);
    console.log("event.target.value", event.target.value);
    if (event.target.value === "staffs") {
      dispatch(fetchTeachersSchedule(selectedTerm));
    } else {
      dispatch(fetchSectionsSchedule(selectedTerm));
    }
  };
  const renderScheduleTable = (data, isStaff) => {
    console.log(
      "data========================================================",
      data
    );
    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    return data.map((item) => {
      // Define name based on isStaff flag
      const name = isStaff
        ? item.teacherName
        : `${item.sectionName} ${item.batchName}`;
      const schedule = item.slots;

      return (
        <div key={isStaff ? item.teacherId : item.roomId}>
          <h2 className="table-heading">
            {isStaff ? `Staff: ${name}` : `Room: ${name}`}
          </h2>{" "}
          <table className="styled-table">
            <thead>
              <tr>
                <th>Day</th>
                {periods.map((period) => (
                  <th key={period.periodName}>{period.periodName}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {days.map((day) => {
                const daySlots = {};
                schedule.forEach((slot) => {
                  if (slot.schoolDayName === day) {
                    const periodName = slot.periodName;
                    if (slot.roomName) {
                      daySlots[periodName] = (
                        <div className="cell-content">
                          <span className="subject">{slot.subjectName}</span>
                          <span className="teacher-room">{`(${slot.roomName})`}</span>
                        </div>
                      );
                    } else if (slot.TeacherName) {
                      daySlots[periodName] = (
                        <div className="cell-content">
                          <span className="subject">{slot.subjectName}</span>
                          <span className="teacher-room">{`(${slot.TeacherName})`}</span>
                        </div>
                      );
                    }
                  }
                });

                const filledPeriodsCount = periods.reduce((count, period) => {
                  return daySlots[period.periodName] ? count + 1 : count;
                }, 0);

                return (
                  <tr key={day}>
                    <td>{day}</td>
                    {periods.map((period) => (
                      <td key={period.periodName}>
                        {daySlots[period.periodName] || ""}
                      </td>
                    ))}
                    <td>{filledPeriodsCount}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    });
  };

  /*   const applyFilters = () => {
    let filtered = [...scheduleData];

    if (filters.roomName) {
      filtered = filtered.filter((item) =>
        item.room.roomName
          .toLowerCase()
          .includes(filters.roomName.toLowerCase())
      );
    }

    if (filters.schoolDayName) {
      filtered = filtered.filter((item) =>
        item.schoolDay.schoolDayName
          .toLowerCase()
          .includes(filters.schoolDayName.toLowerCase())
      );
    }

    if (filters.periodName) {
      filtered = filtered.filter((item) =>
        item.schoolDay.period.periodName
          .toLowerCase()
          .includes(filters.periodName.toLowerCase())
      );
    }

    setFilteredData(filtered);
  };
 */
  const columns = [
    {
      title: "Room",
      dataIndex: "room",
      key: "room",
      render: (room) => room.roomName,
      sorter: (a, b) => a.room.roomName.localeCompare(b.room.roomName),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Room"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => clearFilters()}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.room.roomName
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: "Room Type",
      dataIndex: "room",
      key: "roomType",
      render: (room) => room.roomType,
      filters: [
        { text: "Classroom", value: "Classroom" },
        { text: "Laboratory", value: "Laboratory" },
        { text: "Auditorium", value: "Auditorium" },
      ],
      onFilter: (value, record) => record.room.roomType === value,
    },
    {
      title: "School Day",
      dataIndex: "schoolDay",
      key: "schoolDayName",
      render: (schoolDay) => schoolDay.schoolDayName,
      filters: [
        { text: "Monday", value: "Monday" },
        { text: "Tuesday", value: "Tuesday" },
        { text: "Wednesday", value: "Wednesday" },
        { text: "Thursday", value: "Thursday" },
        { text: "Friday", value: "Friday" },
        { text: "Saturday", value: "Saturday" },
        { text: "Sunday", value: "Sunday" },
      ],
      onFilter: (value, record) => record.schoolDay.schoolDayName === value,
    },
    {
      title: "Period",
      dataIndex: "schoolDay",
      key: "periodName",
      render: (schoolDay) => schoolDay.period.periodName,
      sorter: (a, b) =>
        a.schoolDay.period.periodName.localeCompare(
          b.schoolDay.period.periodName
        ),
    },
    {
      title: "Start Time",
      dataIndex: "schoolDay",
      key: "startTime",
      render: (schoolDay) => schoolDay.period.startTime,
      sorter: (a, b) =>
        a.schoolDay.period.startTime.localeCompare(
          b.schoolDay.period.startTime
        ),
    },
    {
      title: "End Time",
      dataIndex: "schoolDay",
      key: "endTime",
      render: (schoolDay) => schoolDay.period.endTime,
      sorter: (a, b) =>
        a.schoolDay.period.endTime.localeCompare(b.schoolDay.period.endTime),
    },
  ];

  const exportToImage = async () => {
    try {
      const tableElement = tableRef.current.querySelector(
        ".ant-table-container"
      );
      const canvas = await html2canvas(tableElement, {
        scale: 2,
        useCORS: true,
        logging: false,
      });
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `schedule-image-${
        new Date().toISOString().split("T")[0]
      }.png`;
      link.click();
      message.success("Image exported successfully");
    } catch (error) {
      console.error("Export to image failed:", error);
      message.error("Failed to export image");
    }
  };

  const exportToPDF = async () => {
    try {
      const tableElement = tableRef.current.querySelector(
        ".ant-table-container"
      );
      const canvas = await html2canvas(tableElement, {
        scale: 2,
        useCORS: true,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [canvas.width, canvas.height],
      });
      pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
      pdf.save(`schedule-${new Date().toISOString().split("T")[0]}.pdf`);
      message.success("PDF exported successfully");
    } catch (error) {
      console.error("Export to PDF failed:", error);
      message.error("Failed to export PDF");
    }
  };

   return (
     <div style={{ padding: "24px" }}>
       <Space direction="vertical" style={{ width: "100%" }} size="large">
         <Card>
           <Space direction="vertical" style={{ width: "100%" }} size="large">
             <div
               style={{
                 display: "flex",
                 flexDirection: "column",
                 gap: "16px",
                 "@media (min-width: 768px)": {
                   flexDirection: "row",
                   alignItems: "center",
                 },
               }}
             >
               <Title
                 level={3}
                 style={{ margin: 0, marginBottom: { xs: "16px", md: 0 } }}
               >
                 School Schedule information
               </Title>

               <Title level={4}>Select Term</Title>
               <Space
                 wrap
                 style={{
                   width: "100%",
                   justifyContent: "flex-start",
                   "@media (min-width: 768px)": {
                     justifyContent: "flex-end",
                   },
                 }}
               ></Space>
               <div className="select-button-container">
                 <select
                   onChange={handleTermChange}
                   value={selectedTerm} // Ensure this is controlled
                   className="term-select"
                 >
                   <option value="" disabled>
                     Select Term
                   </option>{" "}
                   {/* Placeholder option */}
                   {terms &&
                     terms.map((term) => (
                       <option key={term.termId} value={term.termId}>
                         {term.name} - {term.description}
                       </option>
                     ))}
                 </select>
                 {!isTermScheduled && selectedTerm && (
                   <select
                     onChange={handleOptionChange}
                     value={selectedOption} // Ensure this is controlled
                     className="term-select"
                   >
                     <option value="" disabled>
                       Schedule Options
                     </option>{" "}
                     {/* Placeholder option */}
                     <option key={"Room"} value={"Room"}>
                       {" "}
                       Room
                     </option>
                     <option key={"Section"} value={"Section"}>
                       {" "}
                       Section
                     </option>
                   </select>
                 )}
               </div>
               {isTermScheduled && (
                 <>
                   {sectionsScheduleData &&
                     renderScheduleTable(sectionsScheduleData, false)} 
                 </>
               )}
             </div>
           </Space>
         </Card>
       </Space>
     </div>
   );
};

export default ScheduleManagement;
